module.exports = __webpack_public_path__ + "media/images/front/doctorbook_logo-43bc03b3eaa12c0884475ac2a8317004.jpg";